<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>

    <v-row>
      <v-col cols="12" md="2">
        <template>
          <v-autocomplete
            :items="doctors"
            color="white"
            item-text="dr_name"
            item-value="id"
            item-key="id"
            label="Doctor List"
            v-on:change="getReports()"
            v-model="searchParam.doctor_id"
            cols="3"
            outlined
            dense
            :loading="isLoading"
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" md="2">
        <template>
          <v-autocomplete
            :items="operations"
            color="white"
            item-text="name"
            item-value="id"
            item-key="id"
            label="Operation List"
            v-on:change="getReports()"
            v-model="searchParam.operation_id"
            cols="3"
            outlined
            dense
            :loading="isLoading"
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" md="2">
        <template>
          <v-autocomplete
            :items="users"
            color="white"
            item-text="full_name"
            item-value="id"
            item-key="id"
            label="Counselor Name"
            v-on:change="getReports()"
            v-model="searchParam.counselor_id"
            cols="3"
            sm="6"
            :loading="isLoading"
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" md="2">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Month"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            :max="nowDate"
            @click:date="dateSelect"
            type="month"
            v-on:change="getReports()"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2">
        <v-select
          :items="status"
          v-model="search"
          label="Status"
          hide-details
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          hide-details
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <v-btn depressed color="primary" v-on:click="printList">Print</v-btn>
      </v-col>
    </v-row>

    <div id="print">
      <v-card-title>Counselor Incentive</v-card-title>
      <v-data-table
        :headers="headers"
        :items="itemsWithSno"
        class="elevation-1"
        :search="search"
        dense
        mobile-breakpoint="0"
        :loading="loadingstatus"
        loading-text="Loading... Please wait"
        disable-pagination
        :hide-default-footer="true"
      >
<!--        <template v-slot:item.setupclass="{ item }">-->
<!--          <span>-->
<!--            {{ item.setupclass.start_range }} - -->
<!--            {{ item.setupclass.end_range }}-->
<!--          </span>-->
<!--          &lt;!&ndash; <v-tooltip top>-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <v-chip-->
<!--                @click="getPatientCounseling(item)"-->
<!--                dark-->
<!--                v-bind="attrs"-->
<!--                v-on="on"-->
<!--                class="ma-2"-->
<!--                open-->
<!--                prepend-icon="mdi-printer"-->
<!--                color="primary"-->
<!--                label-->
<!--                outlined-->
<!--                small-->
<!--              >-->
<!--              -->
<!--              </v-chip>-->
<!--            </template>-->
<!--            <span>Add Comments</span>-->
<!--          </v-tooltip> &ndash;&gt;-->
<!--        </template>-->
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="getPatientCounseling(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                prepend-icon="mdi-printer"
                color="primary"
                label
                outlined
                small
              >
                <v-icon> mdi-plus </v-icon>
              </v-chip>
            </template>
            <span>Add Comments</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReports">Reset</v-btn>
        </template>
      </v-data-table>
      <v-col cols="12" sm="6">
        <v-card-title>Summary</v-card-title>
        <v-simple-table dense>
          <tbody>
            <tr>
              <th>Counselor Name</th>
              <th>Incentive Amount</th>
            </tr>
            <tr v-for="item in summary" :key="item.id">
              <td v-if="item.counselor">{{ item.counselor.full_name }}</td>
              <td>{{ item.total }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </div>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 7),
      dialog: false,
      newDialog: false,
      menu2: false,

      loadingstatus: true,
      isLoading: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      users: [],
      summary: [],
      status: ["", "active", "cancel"],
      operations: [],
      doctors: [],
      ot_rooms: [],
      searchParam: {
        user: null,
        status: null,
        operation_id: null,
        counselor_id: null,
        doctor_id: null,
      },
      followup_text: "Followup Date",
      followup_type: ["OT Confirm", "Later on"],

      headers: [
        {
          text: "Serial #",
          value: "sno",
        },
        { text: "Counselor name", value: "counselor.full_name" },
        {
          text: "OT Reg. No.",
          value: "ot_registration_id",
        },

        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },
        {
          text: "Doctor",
          value: "doctor.dr_name",
        },
        {
          text: "Operation Name",
          value: "operation.name",
        },

        {
          text: "OT Amount",
          value: "ot_amount",
        },
        // {
        //   text: "Total Incentive",
        //   value: "incentive_amount",
        // },
        {
          text: "Incentive Amount",
          value: "incentive_amount",
        },
        // {
        //   text: "Class",
        //   value: "setupclass",
        // },
        {
          text: "Status",
          value: "status",
        },
      ],
      desserts: [],
      followup_summary: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Counseling",
          disabled: false,
          href: "/",
        },
        {
          text: "Incentive",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    // let logged_user = localStorage.getItem("userId");
    // let parmitted = ["1", "48", "72", "63", "67"];
    // // let parmitted = ["1"];
    // if (parmitted.includes(logged_user)) {
    //   console.log(parmitted);
    // } else {
    //   console.log(parmitted);
    //   return false;
    // }
    this.getReports();
    this.getDoctors();
    this.getUsers();
    this.getOperations();
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    getOperations() {
      atshq
        .get("operations")
        .then((response) => {
          this.operations = response.data.data;
        })
        .catch((e) => {
          this.error_alert.push(e);
        });
    },
    getUsers() {
      atshq
        .get("users/user")
        .then((response) => {
          this.users = response.data.data;
          this.loadingstatus = false;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getDoctors() {
      atshq
        .get("doctors")
        .then((response) => {
          this.doctors = response.data.data;
          this.loadingstatus = false;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getReports() {
      //   let drid =
      //     this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;
      atshq
        .get(
          "ot-module/ot-counselor-incentive?date=" +
            this.date +
            "&doctor_id=" +
            this.searchParam.doctor_id +
            "&operation_id=" +
            this.searchParam.operation_id +
            "&counselor_id=" +
            this.searchParam.counselor_id
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          this.loadingstatus = false;
          this.isLoading = false;
          this.desserts = response.data.data;
          this.summary = response.data.summary;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    dateSelect() {
      this.loadingstatus = true;
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
        '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      // docprint.document.write(
      //   "<head><title>" + this.doctor.dr_name + " || " + this.date + "</title>"
      // );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
        "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
        "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>